import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { indexStore } from "../../store/indexStore";
import { IMG_URl } from "../../common/img_url";
import { useTranslation } from "react-i18next";
import { DarkModeTogle } from "../langSelect/DarkModeTogle";
import Iterator from "../utils/Iterator";
import { Skeleton } from "../ui/skeleton";
import Visibility from "../utils/Visibility";

import SearchField from "../Searchfield/ SearchField";
import { getRecentlyViewed } from "../utils/RecentlyViewed";
import RecentlyViewed from "./Recently/RecentlyViewed";
import MenuModel from "../../Models/MenuModel";
import BranchModel from "../../Models/BranchModel";
import ProductModel from "../../Models/PorductModel";

function NewBranchScreen() {
  const { menus, branch, restaurant, loading, name, description } =
    indexStore();
  const naivgate = useNavigate();
  const onClickMenu = (id: number | string) => {
    naivgate(`${id}`);
  };
  const onRecentlyClick = (item: ProductModel) => {
    naivgate(`${item.menu_id}/${item.id}`);
  };
  const params = useParams();
  const recentlyViewed = getRecentlyViewed(Number(params.branch_id));

  const { t } = useTranslation();

  const descriptionKey: keyof BranchModel =
    description === "description_ar" ? "description_ar" : "description_en";
  const formattedDescription = (branch?.[descriptionKey] ?? "").replace(
    /\n/g,
    "<br/>"
  );
  return (
    <>
      <Visibility visible={!loading}>
        <div className="bg-primary flex flex-col flex-grow gap-5 min-h-screen ">
          {/* <Header noBack={true} /> */}
          <div className="bg-foreground/60 shrink-0 text-onPrimary mx-4 rounded-2xl p-4 mt-4 flex  items-stretch gap-1">
            <div className="w-32 h-32 p-2 rounded-md  shadow-md">
              <img
                className=" w-full h-full aspect-square object-cover"
                src={`${IMG_URl}${restaurant.logo}`}
                alt="logo"
              />
            </div>
            <h6
              className="leading-6 capitalize text-sm text-center font-semibold"
              dangerouslySetInnerHTML={{ __html: formattedDescription }}
            ></h6>
          </div>

          {/* Search */}
          <div className="flex gap-2 items-center px-4 ">
            <SearchField />
            <button className="bg-background rounded-full p-3 shadow-md">
              <DarkModeTogle showText={false} />
            </button>
          </div>

          {/* Menu Grid */}
          <div className="flex-1 flex-col flex gap-3 bg-background text-foreground rounded-t-[2rem] px-4 pt-4 pb-24">
            <h2 className="text-lg font-semibold ">{t("gloabl.menus")}</h2>
            <div className="grid grid-cols-3 gap-4">
              <Iterator
                data={menus}
                render={(item: MenuModel, i) => (
                  <div
                    key={i}
                    className="text-center flex flex-col gap-1"
                    onClick={() => onClickMenu(item.id)}
                  >
                    <img
                      src={` ${IMG_URl}${item.image}`}
                      alt={item.name_en}
                      className="rounded-xl object-cover h-24 md:h-36 w-full "
                    />
                    <p className="text-sm font-semibold ">
                      {item[name as keyof MenuModel]}
                    </p>
                  </div>
                )}
              />
            </div>

            <div className="flex justify-between gap-4 flex-col ">
              <h2 className="text-lg font-semibold">{t("gloabl.recently")}</h2>

              <RecentlyViewed
                recentlyViewed={recentlyViewed}
                onRecentlyClick={onRecentlyClick}
                IMG_URl={IMG_URl}
                name={name as keyof ProductModel}
              />
            </div>
          </div>
        </div>
      </Visibility>
      <Visibility visible={loading}>
        <RenderLoading />
      </Visibility>
    </>
  );
}

export default NewBranchScreen;
const RenderLoading = () => {
  return (
    <>
      <div className=" flex flex-col flex-grow gap-5 min-h-screen ">
        {/* <Header noBack={true} /> */}
        <Skeleton className=" bg-opacity-60 mx-4 rounded-2xl p-4 mt-4 flex justify-between items-start">
          <Skeleton className="w-36 h-36 p-4 rounded-md shadow-md"></Skeleton>
          <div className="flex flex-col gap-2">
            <Skeleton className={"w-36 h-6"} />
            <Skeleton className={"w-36 h-6"} />
          </div>
        </Skeleton>

        <div className="flex gap-2 items-center px-4 ">
          <Skeleton className={"w-full h-11 rounded-full"} />
          <Skeleton className={"w-11 h-11 rounded-full"} />
        </div>

        <Skeleton className="flex-1 flex-col flex gap-4 bg-opacity-50 rounded-t-[2rem] px-4 pt-4 pb-24">
          <Skeleton className={"w-24 h-6"} />
          <div className={`grid grid-cols-3  md:grid-cols-3 gap-5 `}>
            <Iterator
              data={[1, 2, 3, 4, 5, 6]}
              render={() => (
                <div>
                  <Skeleton className={` w-full h-28 rounded-xl md:h-36  `} />
                </div>
              )}
            />
          </div>
          <Skeleton className={"w-24 h-6"} />

          <div className="flex justify-between items-center gap-5  ">
            <Iterator
              data={[1, 2, 3]}
              render={() => (
                <Skeleton className={` w-full h-28 rounded-xl md:h-36  `} />
              )}
            />
          </div>
        </Skeleton>
      </div>
    </>
  );
};
